<template>
    <div class="nav-user-tab-item">
        <v-autocomplete
            dense
            chips
            label="Meine Kunden"
            multiple
            deletable-chips
            hide-no-data
            return-object
            auto-select-first
            :hide-selected = "true"
            v-model       = "selected"
            :items        = "items"
            :menu-props   = "menuProps"
            item-value    = "id"
            item-text     = "name"
            autocomplete  = "off"
            autocorrect   = "off"
            autocapitalize= "off"
            spellcheck    = "false"
            @change       = "onChange"
            append-icon=""
            ref="select"
        >
            <template v-slot:item="data">
                <v-list-item-content>
                    <v-list-item-title class="component-title" v-html="data.item.name"></v-list-item-title>
                </v-list-item-content>
            </template>
            <!--
            <template v-slot:selection="{ item }">
                <v-chip
                    style        = "margin: 1px"
                    close
                    close-icon="mdi-close"
                    class="w-50"
                >
                    <div class="pl-1">
                        <div class="selected-items">
                            {{ item.name }}
                        </div>
                    </div>
                </v-chip>
            </template>
            -->
        </v-autocomplete>
    </div>
</template>

<script>
import Core from "@/modules/core/service/Core";
import Inb  from "@/modules/inb/service/Inb";

export default {
    name: "NavUserCustomer",

    data: () => ({
        selected: [],
        lmCustomer  : false,
        dlsCustomer : false,
        miscCustomer: false,
        menuProps: {
            closeOnClick: true,
            maxHeight: 300,
            auto: false
        }
    }),

    mounted() {
        this.lmCustomer   = this.preferences.lmCustomer;
        this.dlsCustomer  = this.preferences.dlsCustomer;
        this.miscCustomer = this.preferences.miscCustomer;
        this.selected     = this.preferences.customer;

        this.$refs.select.lastItem = 200;
    },

    computed: {
        items () {
            let customer = this.$store.getters.msd.limCustomer;
             customer.forEach(c => c.clazz = 'CustomerDto')

            return customer;
        },

        preferences () {
            return this.$store.getters.preferences;
        },
    },

    methods: {
        onChange () {
            this.preferences.customer = this.selected;
            Core.preferences.store(this, this.preferences).then (() => {
                Inb.refresh(this);
            });
        },
    }
}
</script>

<style scoped>

.selected-items {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 210px;
}


::v-deep .v-select.v-input--dense .v-chip {
    width: calc(100% - 10px);
    margin-bottom: 5px;
    margin-left: 0;
    margin-right: 0;
}

::v-deep .v-select__selections {
    padding-top: 10px;
    padding-bottom: 5px;
    max-height: 555px;
    overflow-y: scroll;
}

::v-deep .v-select__slot {

}

::v-deep .v-chip .v-chip__content {
    width: 100%;
    justify-content: space-between;
}

::v-deep .v-list-item__title {
    font-weight: normal!important;
    line-height: 20px!important;
    font-size: 15px!important;
}

::v-deep .v-icon {
    cursor: pointer;
}

</style>